import { nnThrottleDebounce } from './inc/helpers.js';


// ============================== header color ==============================
export function headerColor() {
    const $components = document.querySelectorAll('.component, .site-footer');

    // throttle and debounce the function
    if ( $components.length ) {
        var $currentComponent = $components[0];

        changeHeaderColor($currentComponent);

        const preTdDoHeaderColor = () => doHeaderColor($components);
        const tdDoHeaderColor = nnThrottleDebounce(preTdDoHeaderColor, 150);
        window.addEventListener('scroll', tdDoHeaderColor);
    }


    function doHeaderColor($components = null) {
        const targetWindowOffset = 20;
        let compExists = false;

        // loop through components for one that exists at the target offset
        $components?.forEach($component => {
            const componentRect = $component.getBoundingClientRect();

            if ( componentRect.top <= targetWindowOffset && componentRect.bottom >= targetWindowOffset && !compExists ) {
                compExists = true;

                if ( $component != $currentComponent ) {
                    $currentComponent = $component;

                    changeHeaderColor($component);
                }
            }
        });

        // handle when there isn't a component over the offest (ex: component margin)
        if ( !compExists && 'none' != $currentComponent ) {
            $currentComponent = 'none';
            changeHeaderColor();
        }
    }

    function changeHeaderColor($component = null) {
        if ( !$component ) {
            document.body.classList.remove('header-is-dark');
        } else if ( 'dark' == $component.dataset.header ) {
            if ( !document.body.classList.contains('header-is-dark') ) {
                document.body.classList.add('header-is-dark');
            }
        } else {
            document.body.classList.remove('header-is-dark');
        }
    }
    
}



// ============================== sticky header ==============================
export function stickyHeader(options = {}) {
    const defaultOptions = {
        threshold: 200,
        headerSm: true,
        headerHide: false,
        headerHideThreshold: 200,
    };
    options = { ...defaultOptions, ...options };

    const minDelta = 5; // ignore tiny scroll jitter
    let lastScrollY = window.scrollY;

    const updateScrollClasses = () => {
        const scrollY = window.scrollY;
        const delta = scrollY - lastScrollY;

        if ( options.headerSm ) {
            if ( scrollY >= options.threshold ) {
                document.body.classList.add('site-header-sm');
            } else {
                document.body.classList.remove('site-header-sm');
            }
        }

        // Only flip direction after meaningful movement; equal/tiny deltas keep current class
        if ( options.headerHide ) {
            if ( scrollY < options.headerHideThreshold ) {
                document.body.classList.remove('site-header-hide');
                lastScrollY = scrollY;
            } else if ( Math.abs(delta) >= minDelta ) {
                if ( delta < 0 ) {
                    document.body.classList.remove('site-header-hide');
                } else {
                    document.body.classList.add('site-header-hide');
                }

                lastScrollY = scrollY;
            }
        }
    };

    // initial call
    updateScrollClasses();

    // add event listener
    window.addEventListener('scroll', nnThrottleDebounce(updateScrollClasses, 100), { passive: true });
}
